<template>
    <div id="FuelPricingList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Fuel Pricing List</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <router-link v-if="canAdd" class="btn btn-primary pull-right" v-bind:to="{name: 'FuelPricingCreate'}"> <i class="fp-add"> </i> Add</router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content fuel-pricing-list">
                        <!-- <div class="FiltersLabel">Filters</div> -->
                        <data-table-filter-config :moduleName="'fuelPricingList'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange" :moduleName="'fuelPricingList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listFuelPricingTable"
                                    mode="remote"
                                    title="Checks"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-select-all="onSelectAll"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: fuel_price_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link v-if="canUpdate" title="Edit Fuel Pricing" class="fp-edit" v-bind:to="{name: 'FuelPricingEdit',params:{id:props.row.id}}"></router-link>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="fuel_price_value" id="deleteFuelPricingBtn" v-on:click.prevent="fuelPricingDelete" class="btn btn-danger">Delete</button>
                                    </div>

                                </vue-good-table>
                                <custom-pagination
                                        :page-changed="onPageChange"
                                        :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import EventBus from "./event-bus";
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

export default {
    name: "FuelPricingList",
    metaInfo() {
        return {title: "Fuel Pricing List | " +process.env.COPYRIGHT_NAME}
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
        firstLoad: 0,
        permissions: [],
        cantAccessPage: "",
        userColumns:[],
        columns: [
            {
                label: 'Actions',
                field: 'action',
                sortable: false,
            },
            {
                label: 'Type',
                field: 'pricing_type',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Item',
                field: 'item',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Item", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Effective Date',
                field: 'effective_date',
                filterable: true,
                fpFieldType:"date",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Effective Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Price Type',
                field: 'price_type',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Price Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Price Value',
                field: 'price_value',
                filterable: true,
                fpFieldType:"integer",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Price Value", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Customer',
                field: 'customer',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Customer Class',
                field: 'customer_class',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Customer Class", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Contract Type',
                field: 'fp_contract_type',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Contract Type", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Unit No.',
                field: 'unit_no',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Unit No.", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Location',
                field: 'fuel_location',
                filterable: true,
                fpFieldType:"option",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Location", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Created By',
                field: 'created_by',
                filterable: true,
                fpFieldType:"text",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Created By", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        rows: [],
        totalRecords: 0,
        fuel_price_value: false,
        loading:false,
        canUpdate:false,
        canAdd:false,
        action:"list",
        pageKey:'_fuel_pricing_list_',
    }),
    created: function() {

    },
    watch:{
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'list_fuel_pricing') {
                        self.cantAccessPage = true;
                    }
                    if (permissions[i].name == 'delete_fuel_pricing') {
                        self.fuel_price_value = true;
                    }
                    if (permissions[i].name == 'add_fuel_pricing') {
                        self.canAdd = true;
                        self.canUpdate = true;
                    }
                }
            }

        }
    },
    mounted: function() {
        var self = this;

        //self.loadList();
        self.getPermissions();
    },
    methods:{
        cancelAll: function (cancelAll) {
          this.$refs.listFuelPricingTable.unselectAllInternal();
        },
        selectionChanged(param) {
            var self = this;
            self.serverParams.selectedAll = false;
            if(param.selectedRows.length == 100) {
              EventBus.$emit('clear-selection', false);
            } else {
              EventBus.$emit('clear-all-flags', false);
            }
            return;
        },
        loadList() {
            var self = this;
            self.loading = true;
            var data = this.$refs['listFuelPricingTable'].selectedRows;
            var selectedRows = [];

            for (var i = 0; i < data.length; i++) {
                selectedRows.push(self.$refs['listFuelPricingTable'].selectedRows[i].id)
            }
            var fields = {
                page: self.serverParams.page,
                perPage: self.serverParams.perPage,
                filters: self.serverParams.columnFilters,
                sort: self.serverParams.sort,
                action: self.action,
                selectedAll:self.serverParams.selectedAll,
                selectedRows:selectedRows,
            };
            self.firstLoad = 1;
            $.ajax({
                url: process.env.ROOT_API + "/fuel-pricing/list",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    // console.log(data);
                    if (data.status == "success") {

                        if ( self.action == "delete" ) {

                            self.action = "list";
                            $("#deleteFuelPricingBtn").val("Delete");

                            self.$refs.filterComponent.clearSelectAll();
                            self.loadList();
                            EventBus.$emit('clear-all-flags', false);   //hide alert of selection
                        }else{
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if(self.action == "delete"){
                        self.generateStatusCodeMessage(jqXHR,true,'fuel-price-list')
                    }else{
                        self.generateStatusCodeMessage(jqXHR,false,'fuel-price-list')
                    }
                }
            });
        },
        fuelPricingDelete() {
            var self = this;
            self.$swal({
                title: 'Are you sure that you want to delete this Fuel Pricing?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
            }).then((result) => {
                if (result.value) {
                    this.action = "delete";
                    $("#deleteFuelPricingBtn").val("Deleting ...");
                    this.loadList();
                } else {
                  console.log("no");
                }
            });
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/components/FuelPricingList.vue